import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import alarmsActions from '@state/alarms/actions';

function useGroupCondition({ index }) {

  const dispatch = useDispatch();

  const orConditions = useSelector(({ alarms: a }) => a.createEditValues.conditions[index]);
  const isEditDefault = useSelector(({ alarms }) => alarms.isEditDefault);

  const removeGroupCondition = useCallback(() => {

    dispatch(alarmsActions.removeCreateEditValuesGroupConditions(index));

  }, [dispatch, index]);

  const addOrCondition = useCallback(() => {

    dispatch(alarmsActions.addOrCondition(index));

  }, [dispatch, index]);

  useEffect(() => {

    if (orConditions.length === 0) addOrCondition();
    // eslint-disable-next-line
  }, []);

  return {
    removeGroupCondition, orConditions, addOrCondition, isEditDefault,
  };

}

export default useGroupCondition;
